import useTranslation from '../useTranslation';
import type { DroneResponse } from 'generatedTypes/asset/models';
import { parseToItems } from 'utils/parseToItems';

import useDrones from 'hooks/useDrones';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';

const useData = () => {
    const { fetch, isLoading, reset } = useDrones();
    const { NO_DRONES_FOUND } = useTranslation();

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<DroneResponse>({
            fetchFn: fetch,
            noItemsFoundText: NO_DRONES_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        droneItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
